import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BadgeComponent } from './badge.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [BadgeComponent],
  exports: [BadgeComponent],
  imports: [CommonModule, TranslateModule],
})
export class BadgeModule {}
